<template>
  <app-unlogged-layout>
    <app-loading :active="loading" ></app-loading>
    <form @sumbit.prevent="joinOrganization">
      <h1>Organizacje</h1>

      <p v-if="!hasOrganizations">Aby korzystać z Toro musisz być w przynajmniej jednej organizacji, dołącz do niej lub utwórz nową!</p>

      <div class="type-buttons">
        <button type="button" class="btn btn--small" :class="{'btn--gradient': type==0}" @click="type=0">Dołącz</button>
        <button type="button" class="btn btn--small" :class="{'btn--gradient': type==1}" @click="type=1">Utwórz</button>
      </div>
      <br>

      <transition name="fade" mode="out-in">
        <component :is="componentName" @updateForm=updateForm></component>
      </transition>
      <br><br>
      <button
        class="btn btn--gradient"
        @click.prevent="joinOrganization"
        :disabled="!form.correct"
      >Kontynuuj</button>
      <br>
      <button type="button" class="btn btn--small" @click="logout" v-if="!hasOrganizations" >Wyloguj się</button>
      <router-link type="button" class="btn btn--small" to="/" v-else >Wróć</router-link>
      <br>
    </form>
  </app-unlogged-layout>
</template>

<script>
import UnloggedLayout from '@/layout/UnloggedLayout.vue'
import Input from "@/components/Input.vue";
import Loading from "@/components/Loading.vue";
import Join from "@/components/organizations/Join.vue";
import Create from "@/components/organizations/Create.vue";
import {api} from '@/api.js'

export default {
  name: 'join-organization',
  data() {
    return {
      loading: false,
      type: 0,
      form: {
        correct: false
      }
    }
  },
  computed: {
    componentName() {
      return this.type == 0 ? 'app-join' : 'app-create'
    },
    hasOrganizations() {
      return this.$store.state.user.user.organizations.length > 0
    }
  },
  methods: {
    updateForm(payload) {
      this.form = payload
    },
    async joinOrganization() {
      const data = {...this.type, ...this.form}
      if(!data.correct) return
      console.log(data)

      this.loading = true

      try {
        if(this.type == 1) {
          const response = await api.post('/organizations', data)
          console.log(response);
        }

        if(this.type == 0) {
          const response = await api.post(`/invitation/${data.inviteCode}`)
          console.log(response)
        }

        const hadOrganizations = this.hasOrganizations

        await this.$store.dispatch('user/updateUser')
        console.log(this.$store.state.user.user);

        if(!hadOrganizations)
          this.$store.dispatch('user/setActiveOrganization', this.$store.state.user.user.organizations[0].id)

        const nextURL = this.hasOrganizations ? '/organizations' : '/docs'
        this.$router.push(nextURL)

      } catch(e) {
        console.log(e);
      }

      this.loading = false
    },
    logout() {
      this.$store.dispatch('user/logout')
    }
  },
  components: {
    appUnloggedLayout: UnloggedLayout,
    appInput: Input,
    appJoin: Join,
    appCreate: Create,
    appLoading: Loading
  },
  metaInfo: {
    title: 'Dołącz do organizacji'
  }
}
</script>

<style lang="scss" scoped>
  .type-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    .btn {
      margin: 0 12px;
    }
  }
</style>
